<div class="container">
    <br>
    <div class="row mb-3">
        <ng-container *ngIf="tier1">
            <ng-container *ngFor="let t1 of tier1">
                <div class="col-md-8">
                    <h3>Reporte de datos de {{t1.shorttitle}}</h3>
                </div>
                <!--
                <div class="col-md-4 text-right"><i class="fa fa-file-pdf-o fa-2x" style="cursor: pointer;"></i></div>
                -->
                <br>
                <ng-container *ngFor="let o of t1.count">
                    <div class="col-md-6">
                        <h6 *ngIf="o.status == 1">Fichas activas</h6>
                        <h6 *ngIf="o.status == 0">Fichas inactivas</h6>
                    </div>
                    <div class="col-md-6">{{o.total || 0}}</div>
                </ng-container>
                <div class="col-sm-12 mb-4">
                    <div class="table-responsive">
                        <table class="table">
                            <thead class="thead-detail text-center table-success">
                                <tr>
                                    <th scope="col">N°</th>
                                    <th scope="col">Código</th>
                                    <th scope="col">Nombre largo</th>
                                    <th scope="col">Actualizado</th>
                                    <th scope="col" colspan="2">Secciones</th>
                                    <th scope="col" colspan="2">Subsecciones</th>
                                    <th scope="col" colspan="2">Gráficos</th>
                                    <th scope="col" colspan="2">Bibliografías</th>
                                    <th scope="col" colspan="2">Fuentes primarias</th>
                                </tr>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"><small>Visible</small></th>
                                    <th scope="col"><small>Oculto</small></th>
                                    <th scope="col"><small>Visible</small></th>
                                    <th scope="col"><small>Oculto</small></th>
                                    <th scope="col"><small>Visible</small></th>
                                    <th scope="col"><small>Oculto</small></th>
                                    <th scope="col"><small>Visible</small></th>
                                    <th scope="col"><small>Oculto</small></th>
                                    <th scope="col"><small>Visible</small></th>
                                    <th scope="col"><small>Oculto</small></th>
                                </tr>
                            </thead>
                            <tbody class="tbody-report">
                                <tr class="tbody-detail" *ngFor="let o of t1.report; let i = index">
                                    <td>{{i+1}}</td>
                                    <td>{{o.code}}</td>
                                    <td><a class="a-link-report" routerLink="/ficha/{{o.code}}"
                                            target="_blank">{{o.longtitle}}</a></td>
                                    <td>{{o.lastUpdated}}</td>
                                    <td>{{o.sec_act>0 ? o.sec_act : '-'}}</td>
                                    <td>{{o.sec_inact>0 ? o.sec_inact : '-'}}</td>
                                    <td>{{o.sub_act>0 ? o.sub_act : '-'}}</td>
                                    <td>{{o.sub_inact>0 ? o.sub_inact : '-'}}</td>
                                    <td>{{o.graph_act>0 ? o.graph_act : '-'}}</td>
                                    <td>{{o.graph_inact>0 ? o.graph_inact : '-'}}</td>
                                    <td>{{o.bib_act>0 ? o.bib_act : '-'}}</td>
                                    <td>{{o.bib_inact>0 ? o.bib_inact : '-'}}</td>
                                    <td>{{o.ps_act>0 ? o.ps_act : '-'}}</td>
                                    <td>{{o.ps_inact>0 ? o.ps_inact : '-'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br>
                <hr>
            </ng-container>
        </ng-container>
        <br>
    </div>

    <!--Inicio reporte de log -->
    <br>

    <div class="row">
        <div class="col-md-8">
            <h3>Reporte de log de cambios</h3>
        </div>
        <div class="col-md-4 text-end">
            <button class="btn-add">
                <i (click)="downloadPdf()" class="fa fa-file-pdf-o" style="cursor: pointer;"> </i>
                Descargar LOG
            </button>
        </div>
    </div>


    <div class="w-75 p-3 mb-2">
        <div class="col-md-12 text-start mb-4">
            <h4>Filtrar resultado según : </h4>
        </div>

        <div class="form-group row">

            <div class="textOnInput col-12 col-md-3">
                <label class="form-label">Usuario</label>
                <select class="form-select form-input" [(ngModel)]="usuario">
                    <option selected disabled value="">Seleccione un usuario...</option>
                    <option *ngFor="let user of users" value="{{user.lastname}}">
                        {{user.name}} {{user.lastname}}
                    </option>
                </select>
            </div>

            <div class="textOnInput col-12 col-md-3">
                <label class="form-label">Título de ficha</label>
                <input class="form-control" type="text" placeholder="Título de ficha" [(ngModel)]="ficha">
            </div>

            <div class="textOnInput col-12 col-md-3">
                <label class="form-label">Módulo</label>
                <input class="form-control" type="text" placeholder="Título del módulo" [(ngModel)]="modulo">
            </div>

            <div class="col-md-3">
                <button class="btn-add" (click)="consult()"><i class="fa fa-search" aria-hidden="true"> </i>
                    Filtrar</button>
            </div>

        </div>

    </div>

    <br>

    <div class="col-sm-12">
        <table class="table" id="tableLog">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Usuario</th>
                    <th scope="col">Campo de interés</th>
                    <th scope="col">Ficha de investigación</th>
                    <th scope="col">Módulo</th>
                    <th scope="col">Acción realizada</th>
                    <th scope="col">Fecha acción</th>
                </tr>
            </thead>

            <ng-container *ngIf="logFlag==1">
                <tbody class="tbody-report">
                    <tr class="tbody-detail" *ngFor="let list of listLog; let i = index">
                        <td>{{i+1}}</td>
                        <td>{{list.nameUser}}</td>
                        <td>{{list.campo}}</td>
                        <td>{{list.longtitle}}</td>
                        <td>{{list.nameComponent}}</td>
                        <td>{{list.action}}</td>
                        <td>{{list.createdAt | date : 'medium' }}</td>
                    </tr>
                </tbody>
            </ng-container>
            <ng-container *ngIf="logFlag==2">
                <td></td>
                <td></td>
                <td></td>
                <td>
                    <div class="alert alert-warning text-center" role=" alert ">
                        No existen datos relacionados a la búsqueda.
                    </div>
                </td>
                <td></td>
                <td></td>
                <td></td>
            </ng-container>
        </table>
    </div>

    <br>
    <hr>

    <!-- Fin reporte de log -->
    <br>
    <div class="row ">
        <div class="col-12 ">
            <h3>Backup y respaldo de datos</h3>
            <p>Esta sección permite descargar la base de datos en formato SQL para su respaldo adecuado frente a
                incidencias graves con los equipos informáticos. Guarde los archivos generados en dispositivos seguros y
                en unidades diferentes a los servidores
                del CEPLAN.</p>
            <br>
        </div>
        <div class="col-6 ">
            <button class="btn btn-primary p-3 "> Descargar backup de la base de datos</button>
        </div>
        <div class="col-6 ">
            <button class="btn btn-primary p-3 "> Descargar backup de las imagenes y gráficos</button>
        </div>
    </div>

</div>